var _ref2, _ref3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 16 17",
      fill: "none",
      stroke: "white",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.88566 8.61683C9.88566 9.65866 9.04107 10.5032 7.9993 10.5032C6.95746 10.5032 6.11292 9.65866 6.11292 8.61683C6.11292 7.57499 6.95746 6.73047 7.9993 6.73047C9.04107 6.73047 9.88566 7.57499 9.88566 8.61683Z",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 8.46547C2.80124 5.91441 5.18452 4.06396 8 4.06396C10.8154 4.06396 13.1987 5.91443 14 8.46547C13.1987 11.0165 10.8154 12.867 8 12.867C5.18452 12.867 2.80123 11.0165 2 8.46547Z",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgEye, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/eye.779c4bd2.svg";
export { ForwardRef as ReactComponent };